import React, {Fragment} from 'react';
import Image from '../Image';
import {currentLang, breedURL} from '../../../utils/functions';
import {uniqueId} from 'lodash';
import { useTranslation } from 'react-i18next';

const BreedItem = ({data, type, animal}) => {
    const { t } = useTranslation();
    //const url = "/"+currentLang()+"/"+t("menu.breeds")+"/"+data.slug;
    const url = breedURL(data.slug);
    return (
        <div className="list__item" key={uniqueId('breedItem_')}>
            <div className="list__body">
                <div className="list__image">
                    <a className="read-more text--primary" href={url}><Image src={data.image_url} /></a>
                </div>
                <div className="list__description">
                    <div>
                        <h3 className="title"> <a className="text--white" href={url}>{data.title}</a> </h3>
                        <div className="excerpt text--white">{data.summary}</div>
                    </div>
                    
                    <a className="read-more" href={url}>
                        <Fragment> 
                            {t("breeds.readmore")}
                        </Fragment>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default BreedItem
